import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { z } from 'zod';

export enum ShowAs {
  Flow = 'flow',
  List = 'list',
}
export const showAsSchema = z.nativeEnum(ShowAs);

// ? maybe abstract a query param/storage hook preference
export function useAutomationsShowAs() {
  const [storageShowAs, setStorageShowAs] = useLocalStorage(
    'store-rules-show-as',
    'flow',
  );

  const [search, setSearch] = useSearchParams({
    by: storageShowAs,
  });
  const searchShowAs = search.get('as');

  const parsedStorageShowBy = showAsSchema.safeParse(storageShowAs).data;
  const parsedSearchShowBy = showAsSchema.safeParse(searchShowAs).data;
  const showAs = parsedSearchShowBy ?? parsedStorageShowBy ?? ShowAs.Flow;

  const setShowAs = useCallback(
    (changedShowAs: ShowAs) => {
      setStorageShowAs(changedShowAs);
      setSearch({ as: changedShowAs }); // might need to be a smarter search update that only update the params passed
    },
    [setStorageShowAs, setSearch],
  );

  return [showAs, setShowAs] as const;
}
